module.exports = __webpack_public_path__ + "media/images/cart/route03-1242b86447c2e6612a3088456bd574ee.gif";